import { terms } from '../../language/terms';

/**
 * The identity of the glass certificates tabs on the company and site workspaces (D-101),
 * kept apart from the registrations and the routes so a journey can read the same id and
 * label the screen renders without importing the router.
 */

/**
 * The tab id on both workspaces, which is also the route segment a deep link carries:
 * `maintenance/companies/{groupId}/glass-certificates` and
 * `maintenance/companies/{groupId}/sites/{loginSiteId}/glass-certificates`.
 */
export const GLASS_CERTIFICATES_TAB_ID = 'glass-certificates';

/**
 * The tab label. "Certificates" alone would not say WHOSE (architect, 2026-09-06:
 * "Certificates needs some other identifier"), and the short code (PGM) is data the
 * catalogue owns rather than a word the UI may spell (D-067), so the module's own term
 * carries it.
 */
export const GLASS_CERTIFICATES_TAB_LABEL = `${terms.glassAccreditation.value} Certificates`;
